
$(document).ready(function () {

    if (navigator.userAgent.match(/android/i)) {
        document.querySelector('body').classList.add('android');
    }

    // browser detections
    var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;

    function isSafariOnly(){
        if (is_safari){
            if (is_chrome)
                {
                    return false
                }

            else
            {
                document.querySelector('body').classList.add('is-safari');
                return true
            }

        }
        return false;
    }

    isSafariOnly();

    equalheight = function(container){
        var currentTallest = 0,
             currentRowStart = 0,
             rowDivs = new Array(),
             $el

        $(container).each(function() {

            $el = $(this);
            $($el).height('auto')
            topPostion = $el.position().top;

            if (currentRowStart != topPostion) {
                for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs.length = 0; // empty the array
                currentRowStart = topPostion;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
            }
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
        });

    }

    // equal heights for elements: heading and parent
    const divsEqHeights = function(copy, heading, copyAndHeading) {

        if (window.innerWidth >= 768){
            equalheight($(copy));
            equalheight($(heading));
        } else {
            ($(copyAndHeading)).css({height : "auto"}); 
        }
    }

    setTimeout(function() {
        equalheight('.app .app-grid h3');
        equalheight('.gswpromo .app-grid h3');
    }, 2000);

    $(window).resize(function(){
        equalheight('.app .app-grid h3');
        equalheight('.gswpromo .app-grid h3');
    });


    function checkScroll(value, current, previous) {
        return (current >= value && previous < value) || (current <= value && previous > value)
    }

    let previousScroll = getScrollPercent();

    $(window).on('scroll', function () {
        const currentScroll = getScrollPercent();
        if (currentScroll > previousScroll) {
            if (checkScroll(25, currentScroll, previousScroll)) {
                trackGTM('scroll25');
            }

            if (checkScroll(50, currentScroll, previousScroll)) {
                trackGTM('scroll50');
            }

            if (checkScroll(75, currentScroll, previousScroll)) {
                trackGTM('scroll75');
            }

            if (checkScroll(100, currentScroll, previousScroll)) {
                trackGTM('scroll100');
            }
        } else {
            // if in some browser with some scrolling technique (mousewheel, touchpad, keyboard, etc.. )
            // or, on very short pages
            // we get a scroll event at 90% and the next scroll event at 10%
            // the GTM would receive events scroll25, scroll50, scroll75 in this order
            // even though the user was scrolling up and the correct order would be the other way around (75, 50, 25)
            // so for scrolling up we reverse the order of the conditional blocks.
            if (checkScroll(100, currentScroll, previousScroll)) {
                trackGTM('scroll100');
            }

            if (checkScroll(75, currentScroll, previousScroll)) {
                trackGTM('scroll75');
            }

            if (checkScroll(50, currentScroll, previousScroll)) {
                trackGTM('scroll50');
            }

            if (checkScroll(25, currentScroll, previousScroll)) {
                trackGTM('scroll25');
            }
        }

        previousScroll = currentScroll;
    });

    $('#globalSearchLocationBtn').on('click', function () {
        globalstoresearch();
    })

    $("#globalstorelocatorform").submit(function (e) {
        e.preventDefault();
        globalstoresearch();
    });

    /**
     * Video JS players ADA customization
     */
    const videoPlayers = document.querySelectorAll('.video-js');

    videoPlayers.forEach(videoPlayer => {
        const player = videojs(videoPlayer);
        
        player.ready(function() {
            const subsMenu = this.controlBar.subsCapsButton.menu.el_;
            const settingsModal = this.textTrackSettings.el_;
            const settingsButton = subsMenu.querySelector('.vjs-texttrack-settings');

            function handleSettingsOpening() {
                const closeButton = settingsModal.querySelector('.vjs-close-button');
                closeButton.focus();
            }

            console.log(subsMenu, settingsButton);

            settingsButton.addEventListener('click', handleSettingsOpening);
            settingsButton.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    handleSettingsOpening();
                }
            });
            const domVideo = this.children_[0];
            domVideo.removeAttribute('role');
        });
    });
})


var getScrollPercent = function () {
    var h = document.documentElement,
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';
    var percent = parseInt((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100);
    return percent;
}

//global store locator search
var globalstoresearch = function () {
    var oValidation = new Validation();
    if (!oValidation.IsEmpty($('#globalUserAddress').val())) {
        $('#globalUserAddressError').text('');
        $('#globalUserAddressError').hide();
        $('#globalUserAddress').removeAttr('aria-describedby');
        $('#globalUserAddressError').removeAttr('role');

        trackingFloodlight('storelocatorsearch');
        // trackGA4(null, 'global_locatorsearch');

        var exception = "";
        if (document.querySelector("#globalstorelocatorform [name='globalstorelocatorformException']")) {
            exception = document.querySelector("#globalstorelocatorform input[name='globalstorelocatorformException']").value;
        }
        switch (exception) {
            case "nhd":
                trackGA4(null, 'nhd_storelocator');
                break;
            default:
                trackGA4(null, 'global_locatorsearch');
                break;
        }

        setTimeout(function () {
            window.location = '/storelocator?address=' + escape($('#globalUserAddress').val());
        }, 500);
    } else {
        $('#globalUserAddressError').text('Error! Please Enter a Valid Zip Code or City, State');
        $('#globalUserAddressError').show();
        $('#globalUserAddress').attr('aria-describedby', 'globalUserAddressError');
        $('#globalUserAddressError').attr('role', 'alert');
    }
}

//global use my location button
var usemylocationglobal = function (exception) {
    trackingFloodlight('storelocatorsearch');

    // trackGA4(this, 'global_usemylocation');
    if (typeof exception === "undefined") {
        exception = "";
    }
    switch (exception) {
        case "nhd":
            trackGA4(this, 'nhd_mylocation');
            break;
        default:
            trackGA4(this, 'global_usemylocation');
            break;
    }

    setTimeout(function () {
        if (lang == 'en') {
            window.location = '/storelocator' + '?um=1';
        } else {
            window.location = '/tiendas';
        }
    }, 500);
}

var appstoreglobal = function () {
    trackingFloodlight('appstore');
}


var getParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

var round = function (value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

var checkZipcode = function (zip) {
    var isValidZip = /^\d{5}(-\d{4})?$/.test(zip);
    return isValidZip
}

//RESIZING LOCATOR SEARCH INPUT ON SCROLL
$(".store-locator-panel").scroll(function () {

    if ($(".store-locator-panel").scrollTop() > 60 && window.innerWidth < 992) {
        $('#useMylocBtn').hide();
        $(".panel-header").addClass("shrunk");
    } else {
        $('#useMylocBtn').show();
        $(".panel-header").removeClass("shrunk");
    }
});


// use cookies when LocalStorage is not permitted
var cookieStorage = new function () {
    this.getCookie = function (key) {
        var _currentCookie = Cookies.get(key);
        if (_currentCookie) {
            //debug && console.log('cookie is defined if: ' + _currentCookie);
            return Cookies.get(key);
        } else {
            //debug && console.log('cookie is undefined else');
            return false;
        }
    };
    this.setCookie = function (key, value) {
        //debug && console.log('Using cookieStorage');
        //debug && console.log('setCookie ' + key + ' ' + value);
        Cookies.set(key, value);
    };
}();

//global function to setitem in localstorage or cookie
function localStorageSetItemCommon(key, value) {
    if (_SecurityCheck) {
        debug && console.log('Using SET Cookies');
        // use fallback cookies
        cookieStorage.setCookie(key, value);
    } else {
        debug && console.log('Using SET Storage');
        //use localStorage
        localStorage.setItem(key, value);
    }
};

//global function to getitem in localstorage or cookie
function localStorageGetItemCommon(key) {
    if (key != null) {
        if (_SecurityCheck) {
            debug && console.log('Using GET Cookies');
            // use fallback cookies
            return cookieStorage.getCookie(key);
        } else {
            debug && console.log('Using GET STORAGE');
            //use localStorage
            return localStorage.getItem(key);
        }
    } else {
        debug && console.log('localStorageGetItemCommon Key Null');
    }
};


function Validation() {
    var StatesXml = null;

    this.IsAlphaNumeric = function (InputString) {
        if (this.IsEmpty(InputString)) return false;
        InputString += "";
        var DataController = new DataControl();
        var CompareString = DataController.GetAlphaNumbersOnly(InputString);
        var AlphaNumeric = false;
        if (CompareString.length == InputString.length) AlphaNumeric = true;
        return AlphaNumeric;
    }
    this.IsDate = function (InputString) {
        if (this.IsEmpty(InputString)) return false;
        InputString += "";
        var NewDate = new Date(InputString);
        var ValidDate = true;
        if (NewDate.getFullYear().toString() == "NaN") ValidDate = false;
        return ValidDate;
    }
    this.IsEmail = function (InputString) {
        if (this.IsEmpty(InputString)) return false;
        InputString += "";
        var ValidEmail = false;
        var re = new RegExp("^.+@[^\\.].*\\.([a-z]|[A-Z]){2,}$", "gi");
        if (InputString.match(re)) ValidEmail = true;

        // Check to see if address has a comma in it
        if (InputString.indexOf(',') >= 0) {
            ValidEmail = false;
        }
        return ValidEmail;
    }
    this.IsEmpty = function (InputString) {
        var undefined, EmptyFlag = false;
        if (InputString == null) EmptyFlag = true;
        if (InputString == undefined) EmptyFlag = true;
        if (InputString == "") EmptyFlag = true;
        return EmptyFlag;
    }
    this.IsInArray = function (InputArray, Input) {
        var Found = false;
        for (var i = 0; i < InputArray.length; i++) {
            if (InputArray[i] == Input) Found = true;
        }
        return Found;
    }
    this.IsLength = function (InputString, InputLength) {
        var Shorter = false;
        if (this.IsEmpty(InputString)) {
            if (InputLength >= 0) return true;
            return false;
        }
        InputString += "";
        if (InputString.length <= InputLength) Shorter = true;
        return Shorter;
    }
    this.IsNumeric = function (InputString) {
        if (this.IsEmpty(InputString)) return false;
        InputString += "";
        var DataController = new DataControl();
        var CompareString = DataController.GetNumbersOnly(InputString);
        var Numeric = false;
        if (CompareString.length == InputString.length) Numeric = true;
        return Numeric;
    }

    this.IsNumericDecimal = function (InputString) {
        if (this.IsEmpty(InputString) || !InputString.toString().match(/^[-]?\d*\.?\d*$/)) return false;
        return true;
    }


    this.IsPhone = function (InputString) {
        if (this.IsEmpty(InputString)) return false;
        InputString += "";
        var DataController = new DataControl();
        var PhoneString = DataController.GetNumbersOnly(InputString);
        var PhoneNumber = false;
        if (PhoneString.length == 10) PhoneNumber = true;
        return PhoneNumber;
    }
    this.IsState = function (InputString) {
        if (this.IsEmpty(InputString)) return false;
        InputString += "";
        var States = this.GetStatesXml();
        if (document.implementation && document.implementation.createDocument) {
            var Evaluator = new XPathEvaluator();
            var XPathQuery = "//*[@abbrev='" + InputString + "']";
            var StateNode = Evaluator.evaluate(XPathQuery, States.documentElement, null, XPathResult.ANY_UNORDERED_NODE_TYPE, null);
            if (StateNode.singleNodeValue != null) return true;
            return false;
        } else if (window.ActiveXObject) {
            var StateNode = States.selectSingleNode("//*[@abbrev='" + InputString + "']");
            if (StateNode != null) return true;
            return false;
        }
        return false;
    }
    this.IsZip = function (InputString) {
        if (this.IsEmpty(InputString)) return false;
        InputString += "";
        var DataController = new DataControl();
        var ZipString = DataController.GetNumbersOnly(InputString);
        var ZipCode = false;
        if (ZipString.length == 5 || ZipString.length == 9) ZipCode = true;
        return ZipCode;
    }
}
